import {
  Clock,
  FileText,
  Landmark,
  MessageSquareWarning,
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useData } from "../../context/DataContext";
import { useFeatureFlags } from "../../context/FeatureFlagsContext";
import { useNavigation } from "../../context/NavigationContext";
import { useMyWorkMode } from "../../hooks/useMyWorkMode";
import { isFeatureVisible } from "../../utils/featureVisibility";
import { isOpenRequest } from "../../utils/requestHelpers";
import { canUseRemoteAttendance } from "../../utils/workModeHelpers";
import "./HomeQuickActions.css";

const ACTIONS = [
  {
    id: "leave",
    label: "إجازة",
    hint: "طلب إجازة أو إذن",
    icon: FileText,
    feature: "leave",
  },
  {
    id: "attendance",
    label: "حضور",
    hint: "تسجيل حضور وانصراف",
    icon: Clock,
    feature: "attendance",
    requiresRemote: true,
  },
  {
    id: "advance",
    label: "سلفة",
    hint: "طلب سلفة جديدة",
    icon: Landmark,
  },
  {
    id: "my-complaints",
    label: "شكوى",
    hint: "شكوى أو استفسار",
    icon: MessageSquareWarning,
    feature: "complaints",
  },
];

function countMyOpenRequests(pendingRequests, user) {
  const userId = String(user?.id || "");
  const employeeId = String(user?.employeeId || "");
  return (pendingRequests || []).filter((request) => {
    if (!isOpenRequest(request)) return false;
    const ownerId = String(request.userId || "");
    const ownerEmployee = String(request.employeeId || "");
    return (
      (userId && ownerId === userId) ||
      (employeeId && ownerEmployee === employeeId)
    );
  }).length;
}

function HomeQuickActions() {
  const navigation = useNavigation();
  const { user } = useAuth();
  const { pendingRequests } = useData();
  const flags = useFeatureFlags();
  const { workMode } = useMyWorkMode();
  const showRemote = canUseRemoteAttendance(workMode);
  const pendingCount = countMyOpenRequests(pendingRequests, user);

  const visible = ACTIONS.filter((action) => {
    if (action.feature && !isFeatureVisible(flags, action.feature)) return false;
    if (action.requiresRemote && !showRemote) return false;
    return true;
  });

  if (!visible.length || !navigation?.navigate) return null;

  return (
    <section className="ess-quick-actions" aria-label="اختصارات سريعة">
      {visible.map((action) => {
        const Icon = action.icon;
        const badge = action.id === "leave" ? pendingCount : 0;
        return (
          <button
            key={action.id}
            type="button"
            className="ess-quick-action"
            onClick={() => navigation.navigate(action.id)}
          >
            <span className="ess-quick-action-icon" aria-hidden="true">
              <Icon size={20} />
              {badge > 0 ? (
                <span className="ess-quick-action-badge">
                  {badge > 99 ? "99+" : badge}
                </span>
              ) : null}
            </span>
            <span className="ess-quick-action-copy">
              <strong className="ess-quick-action-label">{action.label}</strong>
              <span className="ess-quick-action-hint">{action.hint}</span>
            </span>
          </button>
        );
      })}
    </section>
  );
}

export default HomeQuickActions;
